
export const CommonActionType = {
  MINI_SIDENAV:"MINI_SIDENAV",
  TRANSPARENT_SIDENAV:"TRANSPARENT_SIDENAV",
  WHITE_SIDENAV:"WHITE_SIDENAV",
  SIDENAV_COLOR:"SIDENAV_COLOR",
  TRANSPARENT_NAVBAR:"TRANSPARENT_NAVBAR",
  FIXED_NAVBAR:"FIXED_NAVBAR",
  OPEN_CONFIGURATOR:"OPEN_CONFIGURATOR",
  DIRECTION:"DIRECTION",
  LAYOUT:"LAYOUT",
  DARK_MODE:"DARK_MODE",
  LANGUAGE:'LANGUAGE',
  Cache:'Cache'

}

export const setMiniSidenav = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.MINI_SIDENAV,payload:value });
}

export const setTransparentSidenav = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.TRANSPARENT_SIDENAV,payload:value });
}

export const setWhiteSidenav = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.WHITE_SIDENAV,payload:value });
}


export const setSidenavColor = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.SIDENAV_COLOR,payload:value });
}


export const setTransparentNavbar = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.TRANSPARENT_NAVBAR,payload:value });
}

export const setFixedNavbar = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.FIXED_NAVBAR,payload:value });
}

export const setOpenConfigurator = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.OPEN_CONFIGURATOR,payload:value });
}


export const setDirection = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.DIRECTION,payload:value });
}


export const setLayout = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.LAYOUT,payload:value });
}

export const setDarkMode = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.DARK_MODE,payload:value });
}

export const setCache = (value) => (dispatch) => {
  dispatch({ type: CommonActionType.Cache,payload:value });
}

export const setLanguage = (value) => (dispatch) => {

  dispatch({ type: CommonActionType.LANGUAGE,payload:value });
}